(() => {
  function fillShade() {
    const shade = new URL(location.href).searchParams.get('shade');
    if (!shade) return;
    document.querySelectorAll('input[name="contact[Shade you are considering]"]').forEach(input => { input.value = shade; });
  }
  function init(scope) {
    scope.querySelectorAll('[data-shade-catalog]').forEach(section => {
      if (section.dataset.shadeBound) return;
      section.dataset.shadeBound = 'true';
      const search = section.querySelector('[data-shade-search]');
      if (!search) return;
      const cards = [...section.querySelectorAll('[data-shade-name]')];
      const filters = [...section.querySelectorAll('[data-shade-filter]')];
      const count = section.querySelector('[data-shade-count]');
      const countPattern = count.textContent.replace(String(cards.length), '{count}');
      let family = 'all';
      function update() {
        const query = search.value.toLocaleLowerCase().trim();
        let visible = 0;
        cards.forEach(card => {
          const match = (family === 'all' || family === card.dataset.shadeFamily) && (!query || card.dataset.shadeName.includes(query) || card.dataset.shadeNumber === query.replace(/^#?0*/, ''));
          card.hidden = !match;
          if (match) visible++;
        });
        count.textContent = countPattern.replace('{count}', String(visible));
        section.querySelector('[data-shade-empty]').hidden = visible !== 0;
      }
      search.addEventListener('input', update);
      filters.forEach(button => button.addEventListener('click', () => {
        family = button.dataset.shadeFilter;
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        update();
      }));
    });
    fillShade();
  }
  init(document);
  window.addEventListener('hashchange', fillShade);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
